import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output
} from '@angular/core';

@Directive({
  selector: '[fileDrop]',
  standalone: true
})
export class FileDropDirective {
  @Input() allowedExtensions: string[] = [
    'application/pdf',
    'text/plain',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword'
  ];
  @Input() allowMultipleFiles: boolean = false;
  @Input() maxFileSize: number = 52428800;
  @Output() private filesChangeEmitter: EventEmitter<File[]> =
    new EventEmitter();
  @Output() private invalidFileEmitter: EventEmitter<File> = new EventEmitter();
  @HostBinding('style.background') public background = 'white';

  constructor() {}

  @HostListener('dragover', ['$event'])
  public onDragOver(evt: Event) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#ececec';
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(evt: Event) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'white';
  }

  @HostListener('drop', ['$event'])
  public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'white';
    const files: File[] = Object.values(evt.dataTransfer!.files);
    const validFiles: File[] = files.filter(
      (file) =>
        this.allowedExtensions.includes(file.type) &&
        file.size <= this.maxFileSize
    );
    const invalidFiles: File[] = files.filter(
      (file) =>
        !(
          this.allowedExtensions.includes(file.type) &&
          file.size <= this.maxFileSize
        )
    );
    if (validFiles.length > 0) {
      if (!this.allowMultipleFiles)
        this.filesChangeEmitter.emit([validFiles[0]]);
      if (this.allowMultipleFiles) this.filesChangeEmitter.emit(validFiles);
    } else {
      for (const invalidFile of invalidFiles) {
        this.invalidFileEmitter.emit(invalidFile);
      }
    }
  }
}
